module.exports = __webpack_public_path__ + "static/img/badge-trap-active-mandatory.eee746c.svg";